// extracted by mini-css-extract-plugin
export default {"section":"Categories_section__xKoem","list":"Categories_list__Xdzsd","item":"Categories_item__9Dy8C","image":"Categories_image__RQXn3","title":"Categories_title__meFIE"};